module.exports = __webpack_public_path__ + "static/media/wa_segment_used.4a1beace.png";